import gql from 'graphql-tag'

import { Query } from '../types-graphql'
import { externalCoursesFragment } from './fragments'

export type TDataExternalCourses = Pick<Query, 'externalCourses' | '__typename'>
export const EXTERNAL_COURSES = gql`
  query ($areaId: ID, $q: ExternalCourseRansack, $perPage: Int, $page: Int) {
    externalCourses(areaId: $areaId, q: $q, perPage: $perPage, page: $page) {
      nodes {
        ...ExternalCoursesFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${externalCoursesFragment}
`
